import L from "leaflet"
import shipIconUrl from "../../../assets/images/icons/marker-icon-default.svg"
import { useMap } from "react-leaflet"
import { useEffect } from "react"
import _ from "lodash"

export function getThreeMonthsFromNow(): Date {
  const date = new Date()
  date.setMonth(date.getMonth() + 3)
  return date
}

export function getBGPill(sog: number | null) {
  if (sog === null) {
    return "dark"
  }
  if (sog <= 8.9) {
    return "danger"
  }
  if (sog <= 11.9) {
    return "warning"
  }
  return "success"
}

export function calculateBearing(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
) {
  const toRad = (deg: number) => (deg * Math.PI) / 180
  const y = Math.sin(toRad(lon2 - lon1)) * Math.cos(toRad(lat2))
  const x =
    Math.cos(toRad(lat1)) * Math.sin(toRad(lat2)) -
    Math.sin(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.cos(toRad(lon2 - lon1))
  const bearing = (Math.atan2(y, x) * 180) / Math.PI
  return (bearing + 360) % 360
}

export function splitTrailByDateline(
  positions: { lat: number; lon: number }[]
): [number, number][][] {
  const segments: [number, number][][] = []
  let currentSegment: [number, number][] = []
  let prevLon: number | null = null

  for (const pos of positions) {
    const { lat, lon } = pos

    if (prevLon !== null && Math.abs(lon - prevLon) > 180) {
      // Finish current segment and start a new one
      if (currentSegment.length > 0) {
        segments.push(currentSegment)
      }
      currentSegment = []
    }

    currentSegment.push([lat, lon])
    prevLon = lon
  }

  if (currentSegment.length > 0) {
    segments.push(currentSegment)
  }

  return segments
}

export function getShipIcon(bearing: number, dimmed = false) {
  return L.divIcon({
    className: "VesselTrackingShipIcon",
    html: `
      <img
        src="${shipIconUrl}"
        style="
          width: 32px;
          height: 32px;
          transform: rotate(${bearing}deg);
          transform-origin: center center;
          ${dimmed ? "opacity: 0.15;" : ""}
        "
      />
    `,
    iconSize: [32, 32],
    iconAnchor: [16, 16],
  })
}

export function FlyToSelectedVessel({
  position,
}: {
  position: [number, number] | null
}) {
  const map = useMap()

  useEffect(() => {
    if (position) {
      map.flyTo(position, 6, {
        animate: true,
        duration: 2,
      })
    }
  }, [position, map])

  return null
}

export function formatReceivedAgo(received: number | null): string {
  if (received === null) return "n/a"
  if (received === 0) return "1h ago"
  return `${received}h ago`
}

export function getSegment(label: string): string {
  const segments = ["handysize", "panamax", "supramax", "capesize"]
  const lower = label.toLowerCase()

  for (const segment of segments) {
    if (lower.includes(segment)) {
      return segment
    }
  }

  return "n/a"
}
